// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"295afe35","239":"d8124bcb","453":"ba9655a7","455":"c2cc21bc"}[chunkId] + ".chunk.js";
};